import React, { useEffect } from "react";

import { FaArrowRight, FaRegClock } from "react-icons/fa6";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  const documents = [
    {
      title: "INFORMATIVA PRIVACY SERVIZI AMBULATORIALI",
      // href: "/images/documents/privacy-policy/informativa-privacy-poliambulatorio.pdf",
      href: "/images/documents/privacy-policy/INF-SGDP.02-informativa-privacy-poliambulatorio.pdf",
    },
    {
      title: "INFORMATIVA PRIVACY CASA DI CURA",
      // href: "/images/documents/privacy-policy/informativa-privacy-casa-di-cura.pdf",
      href: "/images/documents/privacy-policy/INF-SGDP.02A-informativa-privacy-casa-di-cura.pdf",
    },
    {
      title: "INFORMATIVA PRIVACY CONTATTI DESIGNATI OSPITI-DEGENTI",
      href: "/images/documents/privacy-policy/informativa-privacy-contatti-designati-ospiti-degenti.pdf",
    },
    {
      title: "INFORMATIVA PRIVACY FORNITORI",
      href: "/images/documents/privacy-policy/informativa-privacy-fornitori.pdf",
    },
    {
      title: "INFORMATIVA PRIVACY CANDIDATI",
      href: "/images/documents/privacy-policy/informativa-privacy-candidati.pdf",
    },
  ];

  return (
    <div className="container mx-auto flex flex-col items-center justify-between px-4 lg:px-6 mb-0 z-30">
      <div className="flex flex-col my-12">
        <h1
          data-aos="fade-right"
          duration="1000"
          className="w-full mx-auto text-left text-blue-text font-light text-3xl lg:text-4xl mt-6 mb-8 lg:mx-0"
        >
          PRIVACY <span className="font-semibold">POLICY</span>
        </h1>

        <p
          data-aos="fade-right"
          duration="1000"
          className="w-full mx-auto text-left text-blue-text font-bold text-xl lg:mt-0 lg:mx-0 underline mb-8"
        >
          USO DEI COOKIE
        </p>

        <p
          data-aos="fade-right"
          duration="1000"
          className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0 mb-8"
        >
          Informativa al trattamento dati personali ai sensi del Regolamento UE
          679/2016 e del D. Lgs. 196/2003
        </p>

        {/* <p className="w-full mx-auto text-blue-text font-bold text-xl lg:mt-0 lg:mx-0 mb-4">
                    Informativa al trattamento dati personali<br />
                    ai sensi del Regolamento UE 679/2016 e del D. Lgs. 196/2003
                </p> */}

        <p
          data-aos="fade-right"
          duration="1000"
          className="text-base font-normal text-black mb-8"
        >
          Le comunichiamo che Titolare del trattamento dei Suoi dati personali
          (ovvero la persona fisica o giuridica che stabilisce come e per quali
          finalità trattare informazioni relative a Lei o ad altre persone
          fisiche che entrano in contatto con la Struttura) è Villa Papa
          Giovanni XXIII S.r.l. con sede legale in piazza Gozzano 1 Torino
          10132. Il menzionato Titolare del trattamento può essere contattato ai
          seguenti recapiti:
        </p>

        <ul className="list-inside">
          <li data-aos="fade-right" duration="1000" className="font-normal">
            <span style={{ fontWeight: 400 }}>Email: </span>
            <a
              href="mailto:privacy@xxiii.it"
              className="text-base font-medium text-blue-primary text-right underline"
            >
              privacy@xxiii.it
            </a>
          </li>
          <li data-aos="fade-right" duration="1000" className="font-normal">
            <span style={{ fontWeight: 400 }}>PEC: </span>
            <a
              href="mailto:papagiovanni23@legalmail.it"
              className="text-base font-medium text-blue-primary text-right underline"
            >
              papagiovanni23@legalmail.it
            </a>
          </li>
          <li data-aos="fade-right" duration="1000" className="font-normal">
            <span style={{ fontWeight: 400 }}>tel. </span>
            <a
              href="tel:011.9675075"
              className="text-base font-medium  text-right no-underline"
            >
              011.9675075
            </a>
          </li>
        </ul>

        <p
          data-aos="fade-right"
          duration="1000"
          className="text-base font-normal text-black mb-4"
        >
          Le comunichiamo altresì che il Titolare del trattamento ha designato
          un Responsabile per la protezione dei dati “Data Protection Officer
          (DPO)” i cui dati di contatto sono i seguenti:
        </p>

        <ul className="list-inside mb-4">
          <li data-aos="fade-right" duration="1000" className="font-normal">
            <span style={{ fontWeight: 400 }}>Email: </span>
            <a
              href="mailto:villapapagiovannixxiii@dpo-sanita.it"
              className="text-base font-medium text-blue-primary text-right no-underline"
            >
              villapapagiovannixxiii@dpo-sanita.it
            </a>
          </li>
          <li data-aos="fade-right" duration="1000" className="font-normal">
            <span style={{ fontWeight: 400 }}>PEC: </span>
            <a
              href="mailto:dpo-sanita@legalmail.it"
              className="text-base font-medium text-blue-primary text-right no-underline"
            >
              dpo-sanita@legalmail.it
            </a>
          </li>
        </ul>
        <div className="grid grid-cols-1 md1:grid-cols-2 xl:grid-cols-3 gap-7 justify-start font-semibold my-8">
          {documents.map(({ title, href }, index) => (
            <div key={index} data-aos="fade-left" className="w-full h-[70px]">
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center items-center bg-blue-primary py-3 px-4 w-full h-full text-center transition hover:opacity-90"
              >
                <p className="leading-snug text-white text-base text-center">
                  {title}
                </p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
